import React, { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  createStyles({
    wrapper: {
      backgroundColor: 'var(--color-white)',
      '@media (min-width:768px)': {
        backgroundColor: '#E8F4FE',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    wrapperInner: {
      '@media (min-width:768px)': {
        width: '640px',
        borderRadius: 10,
        overflow: 'hidden',
        backgroundColor: 'var(--color-white)',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.16)'
      }
    }
  })
);

interface Props {
  children: any;
  footer?: boolean;
}

export const DesktopFullBackground: FC<Props> = ({ children, footer }) => {
  const styles = useStyles({});
  return (
    <div
      className={styles.wrapper}
      style={{ minHeight: footer ? 'calc(100vh - 44px)' : '100vh' }}
    >
      <div className={styles.wrapperInner}>{children}</div>
    </div>
  );
};
